/**
 * Single source of truth for the seat element id. Used both when rendering a bookable seat and
 * when querying for one, so the two can never drift apart.
 */
export const getSeatId = (row, seat) => `bookableSeat-${row}-${seat}`;
//# sourceMappingURL=seatIdUtils.js.map